import { render } from "./ReportPageFilterProposalModal.vue?vue&type=template&id=cf4457d2"
import script from "./ReportPageFilterProposalModal.vue?vue&type=script&lang=js"
export * from "./ReportPageFilterProposalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/ReportPageFilterProposalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf4457d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf4457d2', __exports__)) {
    api.reload('cf4457d2', __exports__)
  }
  
  module.hot.accept("./ReportPageFilterProposalModal.vue?vue&type=template&id=cf4457d2", () => {
    api.rerender('cf4457d2', render)
  })

}


export default __exports__